import { vanillaRequest } from './vanillaRequest';

/**
 * keep only one active async call at one time
 * all callee will share the active one until it resolves
 */
export function share<T extends (...args: any[]) => Promise<any>>(fn: T): T {
  let excutor: Promise<any> | null;
  return ((...args) => (excutor = excutor || fn(...args).finally(() => (excutor = null)))) as T;
}

async function apiSessionCreate(): Promise<any> {
  const requestURL = `${process.env.RAZZLE_API_MOBILE}/session`;

  const req = {
    method: 'POST',
    body: {
      app_type: 'smb',
      mobile_device_type: 'web-partner',
      mobile_device_id: 'pw-web',
    },
    headers: {
      'Content-Type': 'application/json',
      'app-version': '1',
      appkey: 'mobile@webapp',
    },
  };

  console.log(req);
  return vanillaRequest(requestURL, req);
}

let tempSessionTokenStore = '';

/**
 * WARNING: this method is shared
 */
export const getSession = share(async (): Promise<string> => {
  return (
    tempSessionTokenStore || (tempSessionTokenStore = (await apiSessionCreate()).session_token)
  );
});
